import styled, { injectGlobal } from 'styled-components';

import { HeaderStyled } from '@qality/common-components/src/atoms/Header';

// WHEN reusable app wrapper will be created THEN move to root component
// WHEN upgrade to styled-components >=4 THEN replace with createGlobalStyle
injectGlobal`
  // related to @atlaskit/popup
  .atlaskit-portal-container {
    // it's height:0 anwyay
    // fix issue with adding extra space at the end of body
    // (issue similart to inline-block spaces displayed in UI)
    display: block !important;

    .atlaskit-portal {
      // remove not necessary outline at SERVER version, there's global CSS added by one of libs
      // @atlaskit/popup adds this and our component is mounted insied this div
      // but when popup isopened it contains outline made with boxShadow
      // we don't have control on this element as it's added by @atlaskit, so we have to override this value
      // focus is made because of focus-trap on it. This div block contains tabIndex set
      > div {
        // value is taken from @atlaskit component to override not necessary styling
        box-shadow: var(--ds-shadow-overlay, var(--ds-fb-shadow-overlay)) !important;
      }
    }
  }
`;

export const PopupComponentStyled = styled.div`
  padding: 24px;
`;

export const PopupHeaderStyled = styled(HeaderStyled)`
  padding: 0 0 24px;
`;
